
import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { Image } from 'react-bootstrap';
import { TIMESLOTS_API, BaseGatewayImage } from '@app/utils/apiUrl';
import { DeleteMultiple, Get, Put } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../utils/helper';
import { URI_INTERNAL } from '../../../utils/pathLocations';
import { objectShowNumber, messageToast, objectDataTypeBooking, dataTypeBooking } from '../../../utils/define';
import { ConfirmModal } from '../../../modules/modal/ConfirmModal';
import * as moment from 'moment';
import { mapToAppointment } from "../../../models/appoinmentModels"; // Import model


/**
 * @typedef {Object} TimeSlots
 * @property {string} id
 * @property {string} time
 * @property {int} orderNumber
 * @property {boolean} isActive
 * @property {string} createdDate
 */


const TimeSlots = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [selectedItems, setSelectedItems] = useState([]);
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);

    const deleteFuncMutil = useMutation((ids) =>
        DeleteMultiple(TIMESLOTS_API.DELETE, ids)
    );

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['appoinment', valueSearch, page, pageSize],
        async () => {
            const response = await Get(TIMESLOTS_API.GET_ALL_PAGING, null, {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize
            });
            return response;
        }
    );
    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
    };

    const changePage = (number) => {
        setPage(number);
    };


    // Thực hiện xóa nhiều item

    // Xử lý khi chọn/bỏ chọn một mục
    const handleSelectItem = (id) => {
        setSelectedItems((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((item) => item !== id) // Bỏ chọn
                : [...prevSelected, id] // Chọn thêm
        );
    };

    // Xử lý khi chọn/bỏ chọn tất cả
    const handleSelectAll = () => {
        if (selectedItems.length === data?.data?.$values?.length) {
            setSelectedItems([]); // Nếu đã chọn hết thì bỏ chọn
        } else {
            setSelectedItems(data?.data?.$values?.map((item) => item.id) || []); // Chọn tất cả
        }
    };


    // Gọi API để xóa các mục đã chọn
    const handleDeleteSelected = async () => {
        if (selectedItems.length === 0) {
            toast.warning("Vui lòng chọn ít nhất một mục để xóa!");
            return;
        }
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        try {
            if (selectedItems.length > 0) {
                deleteFuncMutil.mutate(selectedItems, {
                    onSuccess: (res) => {
                        if (res.status === 201 || res.status === 200) {
                            toast.success(messageToast.messageToastDeleteSuccess);
                            setSelectedItems([]);
                            refetch();
                        } else {
                            toast.error(messageToast.messageToastDeleteError);
                        }
                    },
                    onError: (res) => {
                        toast.error(messageToast.messageToastTryCatch);
                    }
                });
            }
        } catch (error) {
            toast.error("Có lỗi xảy ra khi xóa!");
        }
        setOpenConfirmDeleteModal(false);
    };

    const cancelDelete = () => {
        setOpenConfirmDeleteModal(false);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title"> Danh sách Khung giờ</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between" style={{ marginBottom: '10px' }}>
                                <form className="form-inline">
                                    <label
                                        htmlFor="exampleEmail2"
                                        className="mr-2"
                                    >
                                        Hiển thị :
                                    </label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={(e) => onChangeShowNumber(e)}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option
                                                key={Number(key)}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                </form>
                                <NavLink
                                    className="nav-link-reject nav-link"
                                    to={URI_INTERNAL.TIMESLOTS_ADD_PATH}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                    >
                                        Thêm mới
                                    </button>
                                </NavLink>
                            </div>
                            {isLoading ? (
                                <div>Loading...</div>
                            ) : isError ? (
                                <div>
                                    An error has occurred: ${error.message}
                                </div>
                            ) : (
                                <div
                                    id="example2_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                >
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr role="row">
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                onChange={handleSelectAll}
                                                                checked={
                                                                    selectedItems.length ===
                                                                    data?.data?.$values?.length
                                                                }
                                                            />
                                                        </th>
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Khung giờ
                                                        </th>
                                                        <th className="sorting">
                                                            OrderNumber
                                                        </th>
                                                        <th className="sorting">
                                                            Trạng thái
                                                        </th>
                                                        <th className="sorting">
                                                            Hành động
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {data?.data?.$values && data?.data?.$values.length > 0 ? (
                                                    <tbody>
                                                        {data?.data?.$values.map(
                                                            (item, index) => (
                                                                <tr
                                                                    key={Number(
                                                                        index
                                                                    )}
                                                                    className="odd"
                                                                >
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedItems.includes(item.id)}
                                                                            onChange={() => handleSelectItem(item.id)}
                                                                        />
                                                                    </td>
                                                                    <td className="dtr-control sorting_1">
                                                                        {index +
                                                                            1 +
                                                                            (page -
                                                                                1) *
                                                                            pageSize}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.time
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.orderNumber
                                                                        }
                                                                    </td>

                                                                    <td>
                                                                        <div
                                                                            className={
                                                                                item.isActive
                                                                                    ? 'icheck-primary'
                                                                                    : 'icheck-danger'
                                                                            }
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                id={
                                                                                    item.id
                                                                                }
                                                                                name={
                                                                                    item.id
                                                                                }
                                                                                defaultChecked
                                                                            />
                                                                            <label
                                                                                htmlFor={
                                                                                    item.id
                                                                                }
                                                                            >
                                                                                {item.isActive
                                                                                    ? 'Đã kích hoạt'
                                                                                    : 'Chưa kích hoạt'}
                                                                            </label>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <ul className="nav">
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    to={createUrlWithParam(
                                                                                        URI_INTERNAL.TIMESLOTS_EDIT_PATH,
                                                                                        {
                                                                                            id: item.id
                                                                                        }
                                                                                    )}
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Sửa"
                                                                                        className="nav-icon font-icon fas fa-pen"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr className="txt-center">
                                                            <td colSpan="12">
                                                                Không có dữ liệu
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}

                                            </Table>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="d-flex justify-content-between mt-3">
                                            <button
                                                className="btn btn-danger"
                                                onClick={handleDeleteSelected}
                                                disabled={selectedItems.length === 0}
                                            >
                                                Xóa đã chọn
                                            </button>
                                        </div>
                                        <div className="col-sm-12">
                                            <div
                                                className="dataTables_paginate paging_simple_numbers"
                                                id="example2_paginate"
                                            >
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    innerClass="pagination pagination-sm no-margin pull-right"
                                                    activePage={page}
                                                    itemsCountPerPage={Number(
                                                        pageSize
                                                    )}
                                                    totalItemsCount={
                                                        data?.totalRecords
                                                    }
                                                    pageRangeDisplayed={5}
                                                    onChange={(number) =>
                                                        changePage(number)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            )}
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default TimeSlots